import { getLocalData, saveLocalData } from './storage'
import { saveDispatcher, setEmail, loadDispatcher } from '../utils'
import fomService from './fomService'

const dataProviderService = {
  async getByName(name, hideScore) {
    const provider = {
      getData: async () => {
        let localData = getLocalData(name)
        if (localData) {
          return localData
        }
        const response = await fetch(`${name}.json`)
        const data = await response.json()
        console.log('🚀 ~ data loaded:', data)
        return data
      },
      saveData: data => saveLocalData(data, name),
      serviceBaseUrl: import.meta.env.VITE_MEETING_SERVICE_URL,
      serviceAuthToken: await getAnonymousToken(),
      hideLock: true,
      hideScore: hideScore,
    }
    return provider
  },

  async getByWebPlay(playbookId, { actionCardUrl, headersCount }, hideScore, email) {
    const provider = {
      getData: async () => {
        let localData = getLocalData(playbookId)
        if (localData) {
          return localData
        }
        if (actionCardUrl) {
          const response = await fetch(actionCardUrl)
          const data = await response.json()
          console.log('🚀 ~ data loaded:', data)
          if (headersCount === 1 && data.sections.length && data.sections[0].type === 'Separator') {
            // expand single separator if it comes first as it will be hidden
            data.sections[0].isOpened = true
          }
          if (email) {
            setEmail(data, email)
          }
          saveLocalData(data, playbookId)
          return data
        } else {
          throw new Error('No action card found for playbookId: ' + playbookId)
        }
      },
      saveData: data => {
        saveLocalData(data, playbookId)
        saveDispatcher.saveCallback?.(data)
      },
      onActionCardLoaded: data => {
        loadDispatcher.loadCallback?.(data)
      },
      getMode: () => {
        return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
      },
      serviceBaseUrl: import.meta.env.VITE_MEETING_SERVICE_URL,
      serviceAuthToken: await getAnonymousToken(),
      hideLock: true,
      hideScore: hideScore,
    }
    if (headersCount !== null) {
      provider.headers = headersCount
    }
    return provider
  },
}

async function getAnonymousToken() {
  try {
    return await fomService.createAnonymousToken()
  } catch (e) {
    console.error('Failed to get anonymous token:', e)
    return ''
  }
}

export default dataProviderService
